import TagManager from "react-gtm-module";

function MajorsPlusCP({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "majors_plus_cp",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default MajorsPlusCP;
